import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Card, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiWorld} from "react-icons/bi";
import {ColumnsType, TableProps} from "antd/es/table";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import LlocTreball from "../../model/root/LlocTreball";
import {GetLlocTreball} from "../../dao/root/GetLlocTreball";
import LlocDeTreballModal from "./component/LlocDeTreballModal";
import Login from "./Login";
import {PostLlocTreball} from "../../dao/root/PostLlocTreball";

const ControlHoraris = () => {
    const titol: string = "Llocs Treball";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    const [coleccio, setDades] = useState<LlocTreball[]>([]);
    const [llocSelected, setLlocSelected] = useState<LlocTreball>(new LlocTreball());
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nouLloc, setNouLloc] = useState(false);
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetLlocTreball(page);
        setDades(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function togleNouElement(element: LlocTreball) {
        setLlocSelected(element);
        setNouLloc(true);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    const columns: ColumnsType<LlocTreball> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
            render: (estat, ele) =>(
                (ele.nom === 'Itinerant' && <Tag color={Colors.colors.color4}>{ele.nom}</Tag>) || (ele.nom !== 'Itinerant' && ele.nom)
            )
        },
        {
            key: 'longitud',
            title: 'Longitud',
            dataIndex: 'longitud',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{ele.longitud}</Tag>
            )
        },
        {
            key: 'latitud',
            title: 'Latitud',
            dataIndex: 'latitud',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.latitud}</Tag>
            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>{" "}
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => deleteLloc(ele)}><BiTrash/></Button>{" "}
                        </>
                    )}
                </>
            ),
        },
    ];

    const tableProps: TableProps<LlocTreball> = {
        loading
    };
    const onChange: TableProps<LlocTreball>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    function afegirLloc(llocTreball: LlocTreball) {
        setLlocSelected(llocTreball);
        setNouLloc(true);
    }

    async function handleLlocModalClose(element: LlocTreball, guardar: boolean) {
        setNouLloc(false);
        if (guardar) {
            setLoading(true);
            await PostLlocTreball(element, page);
            await checkDades();
        }
    }

    async function deleteLloc(element: LlocTreball) {
        const modified: LlocTreball = {
            ...element,
            estat: -1
        };
        handleLlocModalClose(modified, true);
    }

    const redirigirANuevaPestana = () => {
        window.open('https://www.coordenadas-gps.com/', '_blank');
    };

    if (isLoggedIn) {
        return (
            <>
                <Card bordered={true} className={"elemento"}>
                    <div className={"actionButtons"}>
                        {permisosEdicio &&
                            <>
                                <Button title={"Nou Lloc"} style={{backgroundColor: Colors.colors.color2}}
                                        onClick={() =>
                                            afegirLloc(new LlocTreball())}><BiPlus/></Button>
                            </>
                        }
                        <Button title={"Buscar latitud i longitud"} style={{backgroundColor: Colors.colors.color4}}
                                onClick={redirigirANuevaPestana}><BiWorld/></Button>
                        <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                            checkDades()}><BiRefresh/></Button>
                    </div>
                    <h4 className={"titol"} onClick={toggleTable}>{"Llocs de treball"}</h4>
                    {visible && (
                        <Table
                            {...tableProps}
                            onChange={onChange}
                            columns={columns}
                            dataSource={coleccio}
                        />
                    )}
                </Card>
                {nouLloc && (
                    <LlocDeTreballModal element={llocSelected} onClose={handleLlocModalClose}
                                        visible={nouLloc}/>
                )}
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default ControlHoraris;
